$(document).ready(function ($) {
    // navigation1 onmouse over the overlay, show the icon under nav1 element
    $('.inter-header-nav > nav > div > ul > li > div ')
        .mouseover(function () {
            $(this).prev().addClass('over');
        })
        .mouseleave(function () {
            $(this).prev().removeClass('over');
        });


    $('.inter-header-nav > nav > div > ul > li > a, .inter-header-nav > nav > div > ul > li > span').on('touchstart', function(e) {

        e.preventDefault();

        var thisLink = $(this);

        if($(thisLink).next("div").length < 1) {
            window.location.href = thisLink.attr("href");
        }

        $('#header-nav > div > ul > li').removeClass('selected');
        $('#header-nav > div > ul > li > div').css({visibility: "hidden", opacity: "0"});
        $('#header-nav > div > ul > li > div').prev().removeClass('over');

        $('.extranavi').remove();

        thisLink.parent('li').addClass('selected');
        thisLink.next('div').prepend('<div class="extranavi"><a id="extralink" href="' + thisLink.attr('href') +'">Zur &Uuml;bersicht: ' + thisLink.text() + '<svg class="inter-icon arrow-icon inter-icon-16 icon-white mb-1 ml-2"><use xlink:href="#inter-arrow-open-forward-outline"></use></svg><span id="extraclose" class="float-right"><svg class="inter-icon arrow-icon inter-icon-16 icon-white mb-1 ml-2"><use xlink:href="#inter-clear-solid"></use></svg></span></a></div>');
        thisLink.next('div').css({opacity : 1, visibility: "visible"});

        $('#extraclose').on('touchstart', function(e){

            e.preventDefault();

            $('#header-nav > div > ul > li > div').css({visibility: "hidden", opacity: "0"});

        })


    })

    $('.inter-header-nav > nav > div > ul > li > a, .inter-header-nav > nav > div > ul > li > span').on('doubletap',function(e){

        e.preventDefault();

        var thisLink = $(this);
        location.href = thisLink.attr("href");

    });

    $('body').on('touchstart', function(e){

        var specifiedElement = document.getElementById("header-nav");
        if (specifiedElement != null) {
            document.addEventListener('click', function(event) {
                var isClickInside = specifiedElement.contains(event.target);
                if (isClickInside) {

                }
                else {
                    $('#header-nav > div > ul > li > div').css({visibility: "hidden", opacity: "0"});
                }
            });
        }

    })


});


// HACK Navigation for IE10 & IE11, remove as soon the ancient browser does not need to be supported anymore
$(document).ready(function ($) {
    var isIE10 = (navigator.appVersion.indexOf("MSIE 10") !== -1);
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if (isIE10 || isIE11) {
        $.each($('.inter-header-nav nav'), function( index, div) {
            var rect = div.getBoundingClientRect();
            $navLeft = rect.left;
        });
        $.each($('.inter-header-nav nav>div>ul>li>div'), function( index, div) {
            div.setAttribute("style", "left:" + (-1 * $navLeft) + "px; width: " + ($(window).width() + 10) + "px;")
        });
    }
});

$('body').on("click", ".dropdown-agent", function (e) {
    $(this).parent().is(".show") && e.stopPropagation();
});

$('#agent-btn').on("click", function (e) {
    $('.agent-panel').removeClass("panel-closed");
    if($('.phone').length && $('.mobile').length) {
        $('.modal-content').animate({"padding-bottom":"40px"},300, function() {
            $('.agent-panel').animate({left: 0}, 300).addClass("panel-opened");
        });
    } else {
        $('.agent-panel').animate({left: 0}, 300).addClass("panel-opened");
    }
    $('.normal-panel').animate({opacity: 0}, 200);
});

$('#agent-back-btn').on("click", function (e) {
    $('.agent-panel').removeClass("panel-opened");
    $('.agent-panel').animate({left:260},300, function() {
        $(this).addClass("panel-closed");
        $('.normal-panel').animate({opacity: 1}, 300, function() {
            if($('.phone').length && $('.mobile').length) {
                $('.modal-content').animate({"padding-bottom":"0"}, 300);
            }
        });
    });
});
